module.exports = __webpack_public_path__ + "ab412a54b472bafbcf05ae2c11cfc1b0.png";